export default __webpack_public_path__ + "static/media/cyrus_montazeri.3233b6ad.png";